export default {
	"tips.password.rules": "Password must have at least 8 characters and contain uppercase letter, lowercase letter, numbers and special characters.",
	"tips.contactUs": "Please scan the QR code below to contact our customer service team via WeChat",
}
